<template>
    <div class="code-input">
      <input
        v-for="(digit, index) in code"
        :key="index"
        type="text"
        maxlength="1"
        v-model="code[index]"
        @input="onInput(index)"
        @keydown.backspace="onBackspace(index)"
        ref="inputs"
      />
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        code: ['', '', '', '', '', '']
      };
    },
    methods: {
      onInput(index) {
        if (this.code[index].length === 1 && index < 5) {
          this.$refs.inputs[index + 1].focus();
        }
        this.$emit('input', this.code.join(''));
      },
      onBackspace(index) {
        if (this.code[index] === '' && index > 0) {
          this.$refs.inputs[index - 1].focus();
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .code-input {
    display: flex;
    justify-content: space-between;
    padding-bottom: 30px;
  }
  
  .code-input input {
    width: 40px;
    height: 40px;
    text-align: center;
    font-size: 24px;
    margin: 0 5px;
  }
  </style>
  



// WEBPACK FOOTER //
// CodeInput.vue?1f390dbc